<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon class="mb-2" @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- Botón Cancelar <v-icon left>mdi-close</v-icon> -->
            <!-- <v-btn class="cancel" @click="Cancelar">
            Cancelar
          </v-btn> -->
            <!-- Botón Eliminar desde form-meta -->
            <!--  <form-meta
            :data="registro"
            :remove-commit="'removerApicultura'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          /> -->
            <!-- Botón Guardar -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <div class="text-h4 font-weight-bold">🍯 Cosecha y Venta Apícola</div>
        </v-col>
        <!--   <v-col cols="3">
          <form-meta
            :data="registro"
            :remove-commit="'removerApicultura'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="registro.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Seleccione su Finca *"
            outlined
            dense
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <!--  <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          ></v-select>
        </v-col> 
        <v-row> -->
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="registro.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            dense
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Apiario"
          />
        </v-col>

        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Fecha de esta Producción</div>
        </v-col>
        <!-- <v-col cols="12" md="6">
          <v-menu
            ref="menuFecha"
            v-model="menuFecha"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="registro.fecha"
                label="Fecha de inicio de ciclo*"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              >
                <template v-slot:prepend-inner>
                  <v-icon
                    class="mr-2"
                    @click.stop="menuFecha = true"
                    style="cursor: pointer"
                  >
                    mdi-calendar
                  </v-icon>
                </template>
              </v-text-field>
            </template>

            <v-date-picker
              v-model="registro.fecha"
              @input="menuFecha = false"
              locale="es"
            />
          </v-menu>
        </v-col> -->
        <v-col cols="12">
          <v-text-field
            v-model="registro.fecha"
            label="Fecha de esta Cosecha *"
            :rules="[r.required]"
            outlined
            name="fecha"
            placeholder="aaaa-mm-dd"
            @change="validarFecha(registro.fecha)"
          ></v-text-field>
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <!--        <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha fin"
            range-type="production"
            :rules="[r.required]"
            :date.sync="registro.fecha_fin"
            placeholder="dd-mm-aaaa"
            outlined
            @change="validarFechaf"
          >
          </v-text-field>
          <p v-if="errorinf" style="color: red">{{ errorinf }}</p>
        </v-col> -->

        <!--    <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.int, r.min_num(1), r.max_num(9)]"
            label="Número de Ciclo"
            outlined
            dense
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Datos de cada Colmena</div>
        </v-col>
        <!-- Descripción -->
        <v-col cols="12">
          <v-textarea
            v-model="registro.descripcion"
            counter="1000"
            :rules="[r.required, r.max(1000)]"
            label="Ejemplo*: Colmena 1 - Africana - 15,000 abejas"
            outlined
            auto-grow
            rows="2"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.number="registro.colmenas"
            :rules="[r.required, r.int, r.min_num(1)]"
            label="Cantidad de colmenas *"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12">
          <v-textarea
            v-model="registro.observacion"
            :rules="[r.max(1000)]"
            label="Observación(salud, agresividad) / Tarea Pendiente)"
            auto-grow
            outlined
            rows="3"
          />
        </v-col>

        <v-row class="pa-2" align="center" justify="space-around">
          <v-col cols="5" class="d-flex justify-center">
            <v-btn
              block
              large
              :color="
                seccionActiva === 'produccion' ? 'green darken-3' : 'primary'
              "
              class="white--text font-weight-bold"
              elevation="4"
              @click="activarSeccion('produccion')"
            >
              <v-icon left>mdi-beehive-outline</v-icon>
              Producción
            </v-btn>
          </v-col>

          <v-col cols="5" class="d-flex justify-center">
            <v-btn
              block
              large
              :color="seccionActiva === 'venta' ? 'green darken-3' : 'primary'"
              class="white--text font-weight-bold"
              elevation="4"
              @click="activarSeccion('venta')"
            >
              <span style="font-size: 30px">🛒</span>
              Ventas
            </v-btn>
          </v-col>
        </v-row>

        <!-- listado dinámico de producciones -->
        <v-row v-if="mostrarPlantacion">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="text-h6 font-weight-bold">Producción</span>
            </v-col>
            <v-col cols="12">
              <div class="text-h7">
                Agrega un producto presionando el botón Agrega Nuevo Producto.
              </div>
            </v-col>
          </v-row>
          <!-- Botón para agregar producción -->

          <template v-for="(produccion, index) in registro.producciones">
            <!-- Rubro -->
            <v-col cols="12" md="6" :key="`especie-${index}`">
              <v-select
                v-model="produccion.id_rubro_apicola"
                :no-data-text="$vuetify.noDataText"
                :rules="[r.required]"
                :items="rubros_filtrados"
                item-text="descripcion"
                item-value="id"
                label="¿Qué producto obtuvo? *"
                outlined
                dense
                @input="debounceBuscarRegistroExistente"
              >
                <template v-slot:selection="props">
                  <div v-text="props.item[props.parent.$props.itemText]" />
                </template>
              </v-select>
            </v-col>

            <!-- Total Producido -->
            <v-col cols="12" md="6" :key="`produccion-${index}`">
              <v-text-field
                v-model.number="produccion.produccion"
                :rules="[r.required, r.float]"
                label="Cantidad total producida*"
                outlined
                dense
              >
                <template v-slot:append>
                  <unit-picker
                    :group="`to_${guessUnit(produccion.id_rubro_apicola)}`"
                    @transform="produccion.produccion = $event"
                  />
                </template>

                <!--   <template v-slot:append>
                <unit-picker group="to_l" />
              </template> -->
              </v-text-field>
            </v-col>

            <!-- Identificación colmena -->
            <v-col cols="12" md="6" :key="`anual-${index}`">
              <v-textarea
                v-model="produccion.ingreso_anual"
                :rules="[r.max(200)]"
                label="Detalles de esta producción"
                outlined
                dense
                auto-grow
                rows="2"
              />
            </v-col>

            <!-- Botón eliminar -->
            <v-col
              cols="12"
              md="6"
              :key="`icon-${index}`"
              class="d-flex align-center justify-end"
            >
              <v-btn
                icon
                color="red"
                :disabled="!puedeRemoverProduccion"
                @click="removerProduccion(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>

            <!--  <v-col cols="12" :key="`separa-${index}`">
              <v-divider></v-divider>
            </v-col> -->
          </template>

          <v-col cols="6">
            <v-btn
              block
              rounded
              class="primary--text"
              @click="agregarProduccion"
            >
              <v-icon left color="#6CAF35">mdi-plus</v-icon>
              Agrega Nuevo producto
            </v-btn>
          </v-col>
        </v-row>

        <!-- Componente destino -->
        <div v-if="mostrarVenta" style="margin-top: 5px">
          LLena cada Venta y conocerás si tu trabajo rinde y te da beneficios.
          <destino
            :destinos="registro.destinos"
            :producciones="registro.producciones"
            :listado-destinos="destino"
            :unit-picker="{ group: 'to_l' }"
            :rubros="rubro_apicola"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div>

        <!-- Modal de registro existente -->
        <registro-existente
          :title="'La producción ya existe'"
          :description="'Los datos colocados corresponden a una producción existente. ¿Desea cargar la información?'"
          :loading="modal_registro_existe_loading"
          :modal="modal_registro_existe"
          @cerrarModal="cerrarModalRegistroExistente"
          @cargarDatos="cargarRegistroExistente"
        />
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import { danotrx } from '../../modelos'
import { produccion_apicola, formulario_apicultura } from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Apicultura',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      seccionActiva: 'produccion',
      mostrarPlantacion: true,
      mostrarVenta: false,
      menuFecha: false,
      errorin: '',
      errorinf: '',
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id_rubro_apicola',
      ruta_registros: 'apiculturas',
      ruta_registro: 'apicultura',
      nombre_registros_en_state: 'apiculturas',
      nombre_registro_en_state: 'apicultura',
      dispatch_get_registro: 'getApicultura',
      dispatch_guardar_registro: 'guardarApicultura',
      registro: clona(formulario_apicultura),
      registro_produccion: clona(produccion_apicola),
    }
  },
  computed: {
    ...mapState('listados', ['rubro_apicola']),
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'productor_actual',
    ]),
    ...mapGetters('listados', ['unidadMedidaPorId']),
    rubros_filtrados() {
      const selected = this.registro.producciones.map(
        (v) => v[this.tabla_produccion_id_rubro]
      )
      return this.rubro_apicola.map((v) => ({
        ...v,
        disabled: selected.includes(v.id),
      }))
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Apicultura')
    const id = this.obtenerIdDeRuta()

    // SI ES NUEVO NO TRAE ID
    if (id) {
      this.cargarRegistro(id)
      /*this.registro.fecha = this.formatearFechaParaFormulario(
        this.registro.fecha
      )*/
      //this.registro.fecha_fin = this.formatearFechaParaFormulario(this.registro.fecha_fin)
    } else {
      this.registro = clona(formulario_apicultura)
    }

    this.registro.id_productor = this.productor_actual
    //console.log("this.registro.id_productor",this.registro.id_productor)

    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
  },
  methods: {
    activarSeccion(seccion) {
      this.seccionActiva = seccion
      if (seccion === 'produccion') {
        this.pmostrarProduapi()
      } else {
        this.pmostrarVenta()
      }
    },
    //OJO OJO quizas falte: handleActividadChange(indice)
    pmostrarProduapi() {
      this.mostrarPlantacion = true
      this.mostrarVenta = false
    },
    pmostrarVenta() {
      this.mostrarPlantacion = false
      this.mostrarVenta = true
    },
    guessUnit(id_rubro) {
      const rubro = this.rubros_filtrados.find((a) => a.id === id_rubro)
      return this.unidadMedidaPorId(rubro?.id_unidad_medida ?? 2)
    },
    //VALIDACION PARA AAAA-MM-DD
    validarFecha() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      const fecha = this.registro.fecha
      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
      } else {
        let [, anio, mes, dia] = fecha.match(regexFecha)
        // Convertimos a números enteros
        const diaInt = parseInt(dia, 10)
        const mesInt = parseInt(mes, 10)
        const anioInt = parseInt(anio, 10)
        if (mesInt < 1 || mesInt > 12) {
          this.errorin = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        let diasEnMes = new Date(anioInt, mesInt, 0).getDate()
        if (diaInt < 1 || diaInt > diasEnMes) {
          this.errorin = 'El día no es válido para el mes especificado.'
          return
        }
        this.errorin = ''
      }

      this.debounceBuscarRegistroExistente()
    },
    // VALIDACION PARA DD-MM-AAAA
    /* validarFecha() {
      let regexFecha = /^(\d{2})-(\d{2})-(\d{4})$/
      const fecha = this.registro.fecha
      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar dia, mes y año separado con guiones así: dd-mm-aaaa'
      } else {
        let [, dia, mes, anio] = fecha.match(regexFecha)
        // Convertimos a números enteros
        const diaInt = parseInt(dia, 10)
        const mesInt = parseInt(mes, 10)
        const anioInt = parseInt(anio, 10)
        if (mesInt < 1 || mesInt > 12) {
          this.errorin = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        let diasEnMes = new Date(anioInt, mesInt, 0).getDate()
        if (diaInt < 1 || diaInt > diasEnMes) {
          this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
          return
        }
        this.errorin = ''
      }

      this.debounceBuscarRegistroExistente()
    }, */
    //no se usa *****************
    /* validarFechaf() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{2})-(\d{2})-(\d{4})$/
      const fecha = this.registro.fecha_fin
      if (!regexFecha.test(fecha)) {
        this.errorinf =
          'Favor colocar año, mes y día separado con guiones así: dd-mm-aaaa'
      } else {
        let [, dia, mes, anio] = fecha.match(regexFecha)
        // Convertimos a números enteros
        const diaInt = parseInt(dia, 10)
        const mesInt = parseInt(mes, 10)
        const anioInt = parseInt(anio, 10)

        if (mesInt < 1 || mesInt > 12) {
          this.errorinf = 'El mes debe estar en el rango de 01 a 12.'
          return
        }
        let diasEnMes = new Date(anioInt, mesInt, 0).getDate()
        if (diaInt < 1 || diaInt > diasEnMes) {
          this.errorinf = 'El día no es válido para el mes especificado.'
          return
        }
        this.errorinf = ''
      }
    }, */
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    //esta funcion es para que las fechas se envien en el formato aaaa-mm-dd a la BD

    limpiarRegistrosVacios() {
       // Limpiar producciones vacías
       this.registro.producciones = this.registro.producciones.filter((item) =>
        this.esEntradaValida(item)
      )
      /* this.registro.engorde = this.registro.engorde.filter((item) =>
        this.esEngordeValido(item)
      ) */
      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },

    //antes de guardarycontinuar para no modificar la funcion original que esta en Form.js
    antesDeGuardar() {
      //Limpiar registros vacíos
      this.limpiarRegistrosVacios()
       //Esperar a que Vue actualice
      this.$nextTick(() => {
       //Formatear fechas
      if (this.registro.fecha) {
        this.registro.fecha = this.formatearFechaParaBD(this.registro.fecha)
      }
      if (this.registro.fecha_fin) {
       this.registro.fecha_fin = this.formatearFechaParaBD(this.registro.fecha_fin)
      }

      //aqui llama entonces a la funcion guardar con la fecha lista
      this.guardarYContinuar()
     })
    },

    esEntradaValida(item) {
       return item.id_rubro_apicola && item.produccion
    },

    esDestinoValido(destino) {
      return destino.rubro
    },

    async obtenerUnRegistroONada() {
      //console.log('obtenerUnRegistroONada')
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela

        /* console.log('id_productor', id_productor)
        console.log('ciclor', ciclo)
        console.log('fecha', fecha)
        console.log('id_finca', id_finca)
        console.log('id_parcela', id_parcela) */
        const pruebitas = this.obtenerIdDeRuta()
        //console.log('al reves de obtenerIdruta', pruebitas)

        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_rubro_apicola)
              .map((prod) => prod.id_rubro_apicola)
          : []
        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        //console.log('registro.producciones', this.registro.producciones)
        //console.log('id_rubros', id_rubros)
        //console.log('rubros', rubros)

        // required fields to be fulfilled
        if (ciclo && fecha && id_finca && rubros) {
          /*   console.log(
            'entre aqui ciclo, fecha, id_finca, rubros',
            ciclo,
            fecha,
            id_finca,
            rubros
          ) */

          const { status, data } = await this.$store.dispatch(
            'registros/listarApiculturasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          //console.log('status y data', status, data)

          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    Cancelar() {
      this.$router.push('/ru/apiculturas')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
  },
}
</script>

<style>
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
